import * as MD from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LockIcon from '@material-ui/icons/Lock';
import moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../../Store';
import { I18N } from '../../../Store/I18n/Types';
import { IUserState } from '../../../Store/User/Types';
import {
	getACLUsers,
	impersonate,
	modifyACLUserIsActive,
	modifyACLUserDateExpire,
} from '../../../Store/UserManagement/Actions';
import {
	IUserManagementState,
	IUserSearchParams,
	IUserSearchParamsSorting,
	UserACL,
} from '../../../Store/UserManagement/Types';
import { getTheme } from '../../../Themes';
import { capitalize } from '../../../Utils/String';
import { adjustForTimezone, getDateHourZero } from '../../../Utils/Time';
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyString,
	isNullOrUndefinedOrZero,
} from '../../../Utils/Various';
import { ChannelsPopup } from './ChannelsPopup';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	userManagement: IUserManagementState;
}

interface IState {
	currentID: number;
	currentParentID: number;
	openedUser: number;
	page: number;
	resultsPerPage: number;
	params: IUserSearchParamsSorting;
	deleteConfirmationOpen: boolean;
	anchorMenu: null | HTMLElement;
	anchorMenuChannel: null | HTMLElement;
	openDialog: boolean;
	userToDelete: UserACL | null;
	showChannelsPopup: boolean;
}

interface IPropsFromDispatch {
	getACLUsers: typeof getACLUsers;
	impersonate: typeof impersonate;
	modifyACLUserIsActive: typeof modifyACLUserIsActive;
	modifyACLUserDateExpire: typeof modifyACLUserDateExpire;
}

const theme = getTheme();

const styles = MD.createStyles({
	row: {
		'& > *': {
			borderBottom: 'unset',
		},
	},
	table: {
		minWidth: 750,
	},
	margin: {
		margin: theme.spacing(1),
	},
	noResult: {
		textAlign: 'center',
		fontSize: 'large',
	},
	smallIcon: {
		padding: '3px',
	},
	cell5: {
		width: '5%',
	},
	cell10: {
		width: '10%',
	},
	cell125: {
		width: '12.5%',
	},
	cell15: {
		width: '15%',
	},
	cell20: {
		width: '20%',
	},
});

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class UserManagementContentUsersListComponent extends React.Component<
	AllProps,
	IState
> {
	private switchTimer = -1;
	private headers = [
		{ key: '0_header', size: 5, name: '', filtered: false, admin: false },
		{ key: '1_header', size: 5, name: 'ID', filtered: true, admin: false },
		{ key: '2_header', size: 10, name: 'NAME', filtered: true, admin: false },
		{ key: '3_header', size: 10, name: 'FIRSTNAME', filtered: true, admin: false },
		{ key: '4_header', size: 10, name: 'USERNAME', filtered: true, admin: false },
		{ key: '5_header', size: 10, name: 'EMAIL', filtered: false, admin: false },
		{ key: '6_header', size: 5, name: 'GROUP', filtered: false, admin: false },
		{
			key: '7_header',
			size: 15,
			name: 'DISPLAY RIGHTS',
			filtered: false,
			admin: false,
		},
		{ key: '8_header', size: 15, name: 'CHANNELS', filtered: false, admin: true },
		{
			key: '9_header',
			size: 15,
			name: 'IMPERSONATE',
			filtered: false,
			admin: true,
		},
	];

	public constructor(props: AllProps) {
		super(props);
		this.state = {
			currentID: 0,
			currentParentID: 0,
			openedUser: -1,
			page: 0,
			resultsPerPage: 50,
			params: {
				sortingBy: 'ID',
				sortingOrder: 'asc',
			},
			deleteConfirmationOpen: false,
			anchorMenu: null,
			anchorMenuChannel: null,
			openDialog: false,
			userToDelete: null,
			showChannelsPopup: false,
		};
	}

	public componentDidMount() {
		if (
			this.props.router.match.params.groupName !== undefined &&
			!isNaN(parseInt(this.props.router.match.params.groupName, 10))
		) {
			this.props.getACLUsers(
				this.props.user.token,
				{
					isGroup: false,
					researchText: '',
					showInactive: false,
					usersParentID:
						this.props.user.groupID !== 2
							? this.props.user.groupID
							: parseInt(
								this.props.router.match.params.groupName,
								10
							),
				},
				this.state.params,
				this.state.resultsPerPage,
				this.state.page
			);
		} else {
			this.props.getACLUsers(
				this.props.user.token,
				{
					isGroup: false,
					researchText: '',
					showInactive: false,
					usersParentID:
						this.props.user.groupID !== 2
							? this.props.user.groupID
							: 0,
				},
				this.state.params,

				this.state.resultsPerPage,
				this.state.page
			);
		}
	}

	public render(): React.ReactNode {
		return this.props.userManagement.ACLUsersLoading
			? this.renderLoading()
			: this.renderLoaded();
	}

	private renderLoading(): React.ReactNode {
		return (
			<div style={{ paddingTop: 30 }}>
				{this.props.i18n._('Loading')}...
			</div>
		);
	}

	private renderLoaded(): React.ReactNode {
		return (
			<React.Fragment>
				{this.displayCSVButton()}
				{this.state.openDialog && this.drawConfirmationDialog()}
				{this.displayTablePagination()}
				{this.displayTable()}
				<ChannelsPopup
					open={Boolean(this.state.showChannelsPopup)}
					onClose={() => {
						this.setState({ showChannelsPopup: false });
					}}
					targetId={this.state.currentID}
					token={this.props.user.token}
				/>
			</React.Fragment>
		);
	}

	private displayCSVButton(): React.ReactNode {
		return (
			<MD.Button
				onClick={() => {
					let arr = this.props.userManagement.usersACLData;
					let newarr: string[][] = [];
					newarr.push([
						'id',
						'firstname',
						'name',
						'username',
						'email',
						'date creation',
						'date debut',
						'date fin',
						'is active',
						'phone',
						'group name',
					]);
					arr.forEach((element) => {
						let newarrrow = [
							isNullOrUndefinedOrZero(element.id)
								? 'No data'
								: element.id.toString(10),
							isNullOrUndefinedOrEmptyString(element.firstname)
								? 'No data'
								: element.firstname.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.name)
								? 'No data'
								: element.name.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.username)
								? 'No data'
								: element.username.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.email)
								? 'No data'
								: element.email.replace('#', ''),
							isNullOrUndefinedOrEmptyString(
								element.date_creation
							)
								? 'No data'
								: element.date_creation.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.date_debut)
								? 'No data'
								: element.date_debut.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.date_expire)
								? 'No data'
								: element.date_expire.replace('#', ''),
							element.isactive ? 'active' : 'inactive',
							isNullOrUndefinedOrEmptyString(element.phone)
								? 'No data'
								: element.phone.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.parent.name)
								? 'No data'
								: element.parent.name.replace('#', ''),
						];
						newarr.push(newarrrow);
					});

					let csvContent =
						'data:text/csv;charset=utf-8,' +
						newarr.map((e) => e.join(';')).join('\n');

					let encodedUri = encodeURI(csvContent);
					window.open(encodedUri);
				}}
			>
				extract CSV
			</MD.Button>
		);
	}

	private displayTable(): React.ReactNode {
		return (
			<MD.TableContainer
				component={MD.Paper}
				key={'table_container'}
			>
				<MD.Table
					aria-label="collapsible table"
					size="small"
					key={'table_primary'}
				>
					{this.displayTableHead()}
					{this.displayTableBody()}
				</MD.Table>
			</MD.TableContainer>
		);
	}

	private displayTablePagination(): React.ReactNode {
		return (
			<MD.TablePagination
				key={'TablePagination'}
				component="div"
				count={this.props.userManagement.usersCount}
				rowsPerPage={this.state.resultsPerPage}
				page={this.state.page}
				rowsPerPageOptions={[10, 20, 50, 100, 500, 3000]}
				onPageChange={(
					event: React.MouseEvent<HTMLButtonElement> | null,
					page: number
				) => {
					this.setState({
						...this.state,
						page,
					});
					this.refresh();
				}}
				onRowsPerPageChange={(
					event: React.ChangeEvent<
						HTMLTextAreaElement | HTMLInputElement
					>
				) => {
					const rows = parseInt(event.target.value, 10);

					if (isNaN(rows)) {
						return;
					}
					this.setState({
						...this.state,
						page: 0,
						resultsPerPage: rows,
					});
					this.refresh();
				}}
			/>
		);
	}

	private displayTableHead(): React.ReactNode {
		return (
			<MD.TableHead key={'TableHead'}>
				<MD.TableRow
					id="tablerowuser"
					key={'primarytablerow'}
				>
					{this.headers.map((h, i) => this.displayHeader(h, i))}
				</MD.TableRow>
			</MD.TableHead>
		);
	}

	private displayHeader(
		header: {
			key: string;
			name: string;
			filtered: boolean;
			size: number;
			admin: boolean;
		},
		i: number
	): React.ReactNode {
		return header.filtered
			? this.buildFilteredHeader(
				header.name,
				header.key,
				header.size,
				header.admin
			)
			: this.buildUnfilteredHeader(
				header.name,
				header.key,
				header.size,
				header.admin
			);
	}

	private buildFilteredHeader(
		header: string,
		i: string,
		s: number,
		a: boolean
	): React.ReactNode {
		const classes = this.props.classes;
		return !['ID', 'FIRSTNAME', 'NAME', 'USERNAME'].includes(header) ? (
			this.buildUnfilteredHeader(header, i, s, a)
		) : (
			<MD.TableCell
				className={
					s === 10
						? classes.cell10
						: s === 15
							? classes.cell15
							: classes.cell5
				}
				align="left"
				key={'filtered_header_tablecell_' + header}
			>
				<MD.TableSortLabel
					key={'TableSortLabel_' + i}
					active={this.state.params.sortingBy === header}
					onClick={() => {
						this.sortTable(
							header as 'ID' | 'NAME' | 'FIRSTNAME' | 'USERNAME'
						);
					}}
					direction={
						this.state.params.sortingBy === header
							? this.state.params.sortingOrder
							: 'asc'
					}
				>
					{header.length > 0
						? this.props.i18n._(capitalize(header))
						: ''}
				</MD.TableSortLabel>
			</MD.TableCell>
		);
	}

	private buildUnfilteredHeader(
		header: string,
		i: string,
		s: number,
		a: boolean
	): React.ReactNode {
		const classes = this.props.classes;
		if (a && this.props.user.groupID === 2) {
			return (
				<MD.TableCell
					className={
						s === 10
							? classes.cell10
							: s === 15
								? classes.cell15
								: classes.cell5
					}
					align="left"
					key={
						'unfiltered_header_tablecell_' + header
					}
				>
					{header.length > 0
						? this.props.i18n._(capitalize(header))
						: ''}
				</MD.TableCell>
			);
		} else if (!a) {
			return (
				<MD.TableCell
					className={
						s === 10
							? classes.cell10
							: s === 15
								? classes.cell15
								: classes.cell5
					}
					align="left"
					key={
						'unfiltered_header_tablecell_' + header
					}
				>
					{header.length > 0
						? this.props.i18n._(capitalize(header))
						: ''}
				</MD.TableCell>
			);
		}
		return null;
	}

	private sortTable(param: 'ID' | 'FIRSTNAME' | 'NAME' | 'USERNAME') {
		if (this.state.params.sortingBy === param) {
			this.state.params.sortingOrder === 'asc'
				? this.setState({
					...this.state,
					params: {
						...this.state.params,
						sortingOrder: 'desc',
					},
				})
				: this.setState({
					...this.state,
					params: {
						...this.state.params,
						sortingOrder: 'asc',
					},
				});
		} else {
			this.setState({
				...this.state,
				params: {
					...this.state.params,
					sortingBy: param,
					sortingOrder: 'asc',
				},
			});
		}
		this.refresh();
	}

	private displayTableBody(): React.ReactNode | string {
		return this.props.userManagement.usersCount === 0
			? this.displayNoResult()
			: this.displayResult();
	}

	private displayResult(): React.ReactNode {
		return (
			<MD.TableBody>
				{this.props.userManagement.usersACLData.map((u, i) =>
					this.generateRow(u, i)
				)}
			</MD.TableBody>
		);
	}

	private displayNoResult(): React.ReactNode {
		const classes = this.props.classes;

		return (
			<MD.TableBody>
				<MD.TableRow>
					<MD.TableCell colSpan={10} className={classes.noResult}>
						{this.props.i18n._('No result')}
					</MD.TableCell>
				</MD.TableRow>
			</MD.TableBody>
		);
	}

	private closeDialog() {
		this.setState({ openDialog: false });
	}
	private drawConfirmationDialog() {
		if (this.state.userToDelete !== null) {
			let user: UserACL = this.state.userToDelete;
			return (
				<MD.Dialog open={this.state.openDialog}>
					<MD.DialogTitle>
						{' '}
						{this.props.i18n._('Confirm delete user ?')}{' '}
					</MD.DialogTitle>
					<MD.DialogContent>
						<MD.DialogContentText>
							{this.props.i18n._(
								'Do you really want to delete this user'
							)}
						</MD.DialogContentText>
					</MD.DialogContent>
					<MD.DialogActions>
						<MD.Button onClick={this.closeDialog.bind(this)}>
							{this.props.i18n._('Cancel')}
						</MD.Button>
						<MD.Button onClick={() => this.handleUserDelete(user)}>
							{this.props.i18n._('Confirm')}
						</MD.Button>
					</MD.DialogActions>
				</MD.Dialog>
			);
		}
		return null;
	}

	private handleUserDelete(user: UserACL) {
		this.props.modifyACLUserIsActive(this.props.user.token, user.id, false);
		this.props.modifyACLUserDateExpire(
			this.props.user.token,
			user.id,
			moment(
				adjustForTimezone(getDateHourZero(new Date())).toISOString()
			).format('DD/MM/YYYY HH:mm:ss')
		);
		this.setState({ openDialog: false });
	}

	private openUserDeleteForm(user: UserACL) {
		this.setState({
			openDialog: true,
			userToDelete: user,
		});
	}

	private generateRow(user: UserACL, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={`fragment_row_${i}`}>
				<MD.TableRow
					className={classes.row}
					key={'main_row' + i}
				>
					<MD.TableCell key={`cell_collapse_${i}`}>
						<MD.IconButton
							aria-label="expand row"
							size="small"
							onClick={() => {
								if (this.state.openedUser === user.id) {
									this.setState({ openedUser: -1 });
								} else {
									this.setState({ openedUser: user.id });
								}
							}}
						>
							{this.state.openedUser === user.id ? (
								<KeyboardArrowUpIcon />
							) : (
								<KeyboardArrowDownIcon />
							)}
						</MD.IconButton>
					</MD.TableCell>
					<MD.TableCell component="th" scope="row" key={`cell_id_${i}`}>
						{user.id}
					</MD.TableCell>
					<MD.TableCell
						key={`cell_name_${i}`}
						className={classes.cell15}
						align="left"
						title={user.name}
					>
						{isNullOrUndefined(user.name) ? '' : capitalize(user.name)}
					</MD.TableCell>
					<MD.TableCell
						key={`cell_firstname_${i}`}
						className={classes.cell15}
						align="left"
						title={user.firstname}
					>
						{isNullOrUndefined(user.firstname)
							? ''
							: capitalize(user.firstname)}
					</MD.TableCell>
					<MD.TableCell
						key={`cell_username_${i}`}
						className={classes.cell15}
						align="left"
						title={user.username}
					>
						{user.username}
					</MD.TableCell>
					<MD.TableCell
						key={`cell_email_${i}`}
						className={classes.cell15}
						align="left"
						title={user.email}
					>
						{isNullOrUndefined(user.email) ? '' : user.email}
					</MD.TableCell>
					<MD.TableCell
						key={`cell_parent_${i}`}
						className={classes.cell15}
						align="left"
						title={user.parent.name}
					>
						{isNullOrUndefined(user.parent.name)
							? ''
							: user.parent.name.toUpperCase()}
					</MD.TableCell>
					<MD.TableCell align="left"
						key={`cell_buttons_1_${i}`}>
						<IconButton
							className={classes.smallIcon}
							color="primary"
							aria-label="rights picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/users/rights/${user.id}`
								);
							}}
						>
							<LockIcon />
						</IconButton>
						<IconButton
							className={classes.smallIcon}
							color="primary"
							aria-label="edit picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/users/modify/${user.id}`
								);
							}}
						>
							<EditIcon />
						</IconButton>
						<IconButton
							className={classes.smallIcon}
							color="primary"
							aria-label="edit picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => this.openUserDeleteForm(user)}
						>
							<DeleteIcon style={{ color: red[500] }} />
						</IconButton>
					</MD.TableCell>
					{this.props.user.groupID === 2
						? [
							<MD.TableCell align="left"
								key={`cell_buttons_2_${i}`}>
								<MD.Button
									aria-controls="menu-channel"
									aria-haspopup="true"
									onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
										this.setState({
											currentID: user.id,
											currentParentID: user.parent.id,
										});
										this.openMenuChannel(event);
									}}
									style={{ marginRight: '8px' }}
								>
									Channels
								</MD.Button>
								<MD.Button
									color="primary"
									onClick={() => {
										this.setState({
											currentID: user.id,
											showChannelsPopup: true
										});
									}}
								>
									Quick Edit
								</MD.Button>
								<MD.Menu
									id="menu-channel"
									anchorEl={this.state.anchorMenuChannel}
									keepMounted
									open={Boolean(this.state.anchorMenuChannel)}
									onClose={() => this.closeMenuChannel()}
								>
									<MD.MenuItem
										key={"mediaarchiver-global"}
										onClick={() => {
											this.props.router.history.push(
												`/apps/mediaarchiver-user/${this.state.currentID}`
											);
										}}
									>
										Mediaarchiver - global
									</MD.MenuItem>
									<MD.MenuItem
										key={"mediaarchiver-tpp"}
										onClick={() => {
											this.props.router.history.push(
												`/apps/mediaarchiver-tpp-user/${this.state.currentID}`
											);
										}}
									>
										Mediaarchiver - TPP
									</MD.MenuItem>
									<MD.MenuItem
										key={"mediaarchiver-stt"}
										onClick={() => {
											this.props.router.history.push(
												`/apps/mediaarchiver-stt-user/${this.state.currentID}`
											);
										}}
									>
										MediaArchiver - STT
									</MD.MenuItem>
									<MD.MenuItem
										key={"mytrack-global"}
										onClick={() => {
											this.props.router.history.push(
												`/apps/mytrack-group/${this.state.currentParentID}`
											);
										}}
									>
										MyTrack - Global
									</MD.MenuItem>
								</MD.Menu>
							</MD.TableCell>,<MD.TableCell align="left"
								key={`cell_buttons_3_${i}`}>
								<MD.Button
									aria-controls="simple-menu"
									aria-haspopup="true"
									onClick={(
										event: React.MouseEvent<HTMLButtonElement>
									) => {
										this.setState({ currentID: user.id });
										this.setState({
											currentParentID: user.parent.id,
										});
										this.openMenu(event);
									}}
								>
									Service
								</MD.Button>
								<MD.Menu
									id="simple-menu"
									anchorEl={this.state.anchorMenu}
									keepMounted
									open={Boolean(this.state.anchorMenu)}
									onClose={(
										event: {},
										reason:
											| 'backdropClick'
											| 'escapeKeyDown'
									) => {
										this.closeMenu();
									}}
								>
									<MD.MenuItem
										onClick={() => {
											this.props.impersonate(
												this.props.user.token,
												this.state.currentID
											);
											setTimeout(() => {
												window.open(
													'https://mytrack-dev.yacast.fr/?token=' +
													this.props
														.userManagement
														.impersonateToken,
													'_blank'
												);
												this.closeMenu();
												this.setState({ currentID: 0 });
											}, 1500);
										}}
									>
										MyTrack
									</MD.MenuItem>

									<MD.MenuItem
										onClick={() => {
											this.props.impersonate(
												this.props.user.token,
												this.state.currentID
											);
											setTimeout(() => {
												window.open(
													'https://adtrack-stg.yacast.fr/?token=' +
													this.props
														.userManagement
														.impersonateToken,
													'_blank'
												);
												this.closeMenu();
												this.setState({ currentID: 0 });
											}, 1500);
										}}
									>
										AdTrack
									</MD.MenuItem>
									<MD.MenuItem
										onClick={() => {
											this.closeMenu();
										}}
									>
										MediaArchiver
									</MD.MenuItem>
									<MD.MenuItem
										onClick={() => {
											this.closeMenu();
										}}
									>
										Talk
									</MD.MenuItem>
								</MD.Menu>
							</MD.TableCell>,
						]
						: null}
				</MD.TableRow>
				<MD.TableRow key={'secondary row' + i}>
					<MD.TableCell
						style={{ paddingBottom: 0, paddingTop: 0 }}
						colSpan={10}
						key={`cell_second_table_main_cell_${i}`}
					>
						<MD.Collapse
							in={this.state.openedUser === user.id}
							timeout="auto"
							unmountOnExit
						>
							<MD.Box margin={1}>
								<MD.Typography
									variant="h6"
									gutterBottom
									component="div"
								>
									{this.props.i18n._('Other informations')}
								</MD.Typography>
								<MD.Table
									size="small"
									aria-label="Other informations"
								>
									<MD.TableHead>
										<MD.TableRow>
											<MD.TableCell
												key={`cell_subtable_title_active_${i}`}>
												{this.props.i18n._('Active')}
											</MD.TableCell>
											<MD.TableCell
												key={`cell_subtable_title_creation_${i}`}>
												{this.props.i18n._('Creation date')}
											</MD.TableCell>
											<MD.TableCell align="left"
												key={`cell_subtable_title_start_${i}`}>
												{this.props.i18n._('Start date')}
											</MD.TableCell>
											<MD.TableCell align="left"
												key={`cell_subtable_title_end_${i}`}>
												{this.props.i18n._('End date')}
											</MD.TableCell>
										</MD.TableRow>
									</MD.TableHead>
									<MD.TableBody>
										<MD.TableRow>
											<MD.TableCell
												key={`cell_subtable_value_active_${i}`}
												component="th"
												scope="row"
											>
												{user.isactive
													? this.props.i18n._('Active')
													: this.props.i18n._('Inactive')}
											</MD.TableCell>
											<MD.TableCell
												key={`cell_subtable_value_creation_${i}`}>
												{user.date_creation}
											</MD.TableCell>
											<MD.TableCell align="left"
												key={`cell_subtable_value_start_${i}`}>
												{user.date_debut}
											</MD.TableCell>
											<MD.TableCell align="left"
												key={`cell_subtable_value_end_${i}`}>
												{isNullOrUndefinedOrEmptyString(
													user.date_expire
												)
													? this.props.i18n._(
														'No end date'
													)
													: user.date_expire}
											</MD.TableCell>
										</MD.TableRow>
									</MD.TableBody>
								</MD.Table>
							</MD.Box>
						</MD.Collapse>
					</MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private emailReduce(email: string): string {
		let emailSplit = email.split('@');
		let newMail = emailSplit[0];
		if (emailSplit[0].length > 10) {
			newMail =
				emailSplit[0].charAt(0) +
				'...' +
				emailSplit[0].charAt(emailSplit[0].length - 1);
		}
		let end = '@';
		if (!isNullOrUndefined(emailSplit[1])) {
			if (emailSplit[1].split('.')[0].length > 7) {
				end =
					end +
					emailSplit[1].split('.')[0].charAt(0) +
					'...' +
					emailSplit[1]
						.split('.')[0]
						.charAt(emailSplit[1].split('.')[0].length - 1) +
					'.' +
					emailSplit[1].split('.')[1];
			} else {
				end = end + emailSplit[1];
			}
		}
		return newMail + end;
	}

	private reduceString(str: string): string {
		return str === undefined
			? ''
			: str.length > 10
				? str.slice(0, 2) + '...' + str.slice(-3)
				: str;
	}

	private reduceLessString(str: string): string {
		return str === undefined
			? ''
			: str.length > 14
				? str.slice(0, 5) + '...' + str.slice(-6)
				: str;
	}

	private closeMenu() {
		this.setState({ anchorMenu: null });
	}

	private openMenu(event: React.MouseEvent<HTMLButtonElement>) {
		this.setState({ anchorMenu: event.currentTarget });
	}

	private closeMenuChannel() {
		this.setState({ anchorMenuChannel: null });
	}

	private openMenuChannel(event: React.MouseEvent<HTMLButtonElement>) {
		this.setState({ anchorMenuChannel: event.currentTarget });
	}

	private refresh() {
		if (this.switchTimer !== -1) {
			window.clearTimeout(this.switchTimer);
		}
		this.switchTimer = window.setTimeout(() => {
			this.props.getACLUsers(
				this.props.user.token,
				null,
				this.state.params,
				this.state.resultsPerPage,
				this.state.page
			);
			this.switchTimer = -1;
		}, 300);
	}
}

const mapStateToProps = (
	{ i18n, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLUsers: (
		token: string,
		params: IUserSearchParams | null,
		paramsSorting: IUserSearchParamsSorting | null,
		resultsPerPage?: number,
		page?: number
	) =>
		dispatch(
			getACLUsers(token, params, paramsSorting, resultsPerPage, page)
		),
	impersonate: (token: string, userId: number) =>
		dispatch(impersonate(token, userId)),
	modifyACLUserIsActive: (token: string, id: number, param: boolean) =>
		dispatch(modifyACLUserIsActive(token, id, param)),
	modifyACLUserDateExpire: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserDateExpire(token, id, param)),
});

export const UserManagementContentUsersList = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(UserManagementContentUsersListComponent));
